export default {
  getSalesIndicator: (state) => state.salesIndicator,
  getAwaitingExportSalesIndicator: (state) => state.awaitingExportSalesIndicator,
  getExpensesIndicator: (state) => state.expensesIndicator,
  getAwaitingExportExpensesIndicator: (state) => state.awaitingExportExpensesIndicator,
  getHRIndicator: (state) => state.hrIndicator,
}